import { Box, Typography, Link } from "@mui/material";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import StaticPage from "../../components/StaticPage";
import ProfileSection from "../../components/ProfileSection";

export default function ContactPage() {
  return (
    <StaticPage title="Contact" subtitle="We'd like to hear from you.">
      <ProfileSection
        icon={<EmailRoundedIcon fontSize="small" />}
        title="Get in touch"
        sx={{ mb: 0 }}
      >
        <Typography color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
          For support, partnership or press questions, email us and we'll get
          back to you.
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography>
            Support:{" "}
            <Link href="mailto:info@thecreatormatch.com" color="secondary.main">
              info@thecreatormatch.com
            </Link>
          </Typography>
        </Box>
      </ProfileSection>
    </StaticPage>
  );
}
